import { PageStrucuture } from "../store";
import { PAGE } from "../actions-constants/page.constants";

const initialPage = new PageStrucuture

export function pageReducer(page:PageStrucuture = initialPage,action):PageStrucuture {
    switch(action.type) {
        case PAGE.SET_NEW_TITLE:
            return {...page,title: action.title}
        default:
            return page
    }
}